import React, { useEffect, useRef } from "react";
import { debounce } from 'throttle-debounce';
import { compose } from "redux";
import classNames from "classnames";

import styles from "fantastic/components/hoc/styles";

import connectActions from "fantastic/lib/connectActions";
import actions from "fantastic/actions";


const Map = props => {
  const {
    id,
    src,
    width,
    dimension,
    natural_height,
    natural_width,
    href,
    alt,
    text_align,
    style,
    update,
    preview,
    mobile,
    css_padding_left,
    css_padding_right,
    css_padding_top,
    css_padding_bottom
  } = props;

  const setImageDimension = img => {
    if (preview) return;
    const width = Math.floor(img.width);
    const height = (img.naturalHeight * width) / img.naturalWidth;

    const attrs = {
      natural_width: img.naturalWidth,
      natural_height: img.naturalHeight,
      width: width,
      dimension: [width, height]
    };
    if (dimension &&
      dimension[0] === width &&
      dimension[1] === height
    ) return;
    if (isNaN(width) || isNaN(height)) return;
    update(id, attrs);
  };

  const wrapImage = (imgTag) => {

    if (href)
      return (
        <a align="center"
          onClick={(e) => e.preventDefault()}
          href={href}>
          {imgTag}
        </a>
      );

    return <div align="center">{imgTag}</div>;
  };

  const debouncedSetImageDimension = useRef(debounce(500, setImageDimension)).current;

  const image = useRef({});

  useEffect(() => {
    if (src) debouncedSetImageDimension(image.current);
  }, [width,
    css_padding_left,
    css_padding_right,
    css_padding_top,
    css_padding_bottom,
    src]);

  if (src) {
    return (
      <div className="fantastic-item__image">
        <div align="center">
          {wrapImage(
            <img
              ref={image}
              src={src}
              alt={alt}
              style={style}
              className={text_align}
              onLoad={e => debouncedSetImageDimension(e.target)}
            />
          )}
        </div>
        <div className="clearfix" />
      </div>
    );
  }

  if (preview) {
    return null;
  }

  return (
    <div className="fantastic-item-imaged">
      <i className="fi fi-map fa-2x fantastic-item-imaged__icon" />
    </div>
  );

}

export default compose(
  connectActions({
    update: actions.updateNode
  }),
  styles("padding")
)(Map);
